import React, { useContext } from 'react';
import { NationalAccountContext } from '../../../../../contexts';
import { EINInputModal } from './EINInputModal';
import { GovernmentAffiliationWarningModal } from './GovernmentAffiliationModal';
import { ConfirmEnrollModal } from './ConfirmEnrollModal';
import { CodeDetailDescription } from '../commons';
export var EINModalContainer = function () {
    var _a = useContext(NationalAccountContext), validResponseState = _a.validResponseState, showModal = _a.showModal;
    return (React.createElement("div", { "data-testid": "EINModalContainer", className: "sui-flex sui-flex-col sui-justify-center sui-font-regular sui-text-1xl" },
        React.createElement(CodeDetailDescription, { validResponseState: validResponseState, showModal: showModal }),
        React.createElement(ModalBody, null)));
};
var ModalBody = function () {
    var validResponseState = useContext(NationalAccountContext).validResponseState;
    if (validResponseState.einGovState) {
        return React.createElement(GovernmentAffiliationWarningModal, null);
    }
    if (validResponseState.requiredEINState) {
        return React.createElement(EINInputModal, null);
    }
    return React.createElement(ConfirmEnrollModal, null);
};
